<template>
  <v-card class="scrollable-div" elevation="3">
    <v-card-title class="headline">
      <v-card-title> Update User </v-card-title>
      <v-btn icon @click="emit('close')" class="square-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-if="UserData" :key="formKey" @submit.prevent="updateUser">
        <v-text-field v-model="state.user.id" label="ID" :counter="10" required></v-text-field>
        <v-text-field v-model="state.user.first_name" label="First Name" :counter="10" required></v-text-field>
        <v-text-field v-model="state.user.last_name" label="Last Name" :counter="10" required></v-text-field>
        <v-text-field v-model="state.user.username" label="User Name" :counter="10" required></v-text-field>
        <v-text-field v-model="state.user.email" label="Email" :counter="10" required></v-text-field>
        <v-text-field v-model="state._password" :type="showPassword ? 'text' : 'password'" label="Password" required
          :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPassword = !showPassword"></v-text-field>

        <v-select v-model="state.class_info" :items="classOptions" item-value="id" item-title="name"
          label="Class Detail*" required multiple class="my-4" />
        <v-row class="justify-end m-2">
          <v-btn class="me-2" @click="updateUser">Submit</v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>


<script setup>
import { ref, watch,computed, watchEffect, defineProps, onMounted, reactive } from "vue";
import { classNames } from "@/services/apiServices";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig"; // Import API config
const props = defineProps({
  UserData: {
    type: Object,
    required: true,
  },
});
const showPassword = ref(false);
const initialState = {
  user: {
    id: "",
    first_name: "",
    last_name: "",
    username: "",
    email: ""
  },
  verified_by: null, 
  class_info: [],    
  _password: ""     
};


const state = reactive({ ...initialState });

// Watch UserData and update state
// watchEffect(() => {
//   if (props.UserData) {
//     state.user.id = props.UserData.user?.id || "";
//     state.user.first_name = props.UserData.user?.first_name || "";
//     state.user.last_name = props.UserData.user?.last_name || "";
//     state.user.email = props.UserData.user?.email || "";
//     state.class_info = props.UserData.class_info?.map((c) => c.id) || [];
//   }
// });
watchEffect(() => {
  if (props.UserData && typeof props.UserData === "object") {
    Object.assign(state, {
      ...initialState,
      user: {
        id: props.UserData.user?.id || "",
        first_name: props.UserData.user?.first_name || "",
        last_name: props.UserData.user?.last_name || "",
        username: props.UserData.user?.username || "",
        email: props.UserData.user?.email || ""
      },
      class_info: props.UserData.class_info?.map((c) => c.id) || [],// Only storing the IDs in class_info
      _password: props.UserData?._password || ""
    });

    // console.log("Updated state:", state);
  }
});


const emit = defineEmits(["updatedUser", "close"]);

const formKey = ref(0);
const classOptions = ref([]);
// const classOptions = computed(() => {
//   return UserData.map(item => ({
//     value: item.id,  // ID as value
//     name: item.name, // Name as name
//   }));
// });

const successMessage = ref("");
const error = ref(null);



//when new user is adding
watch(
  () => props.UserData,
  (newUser) => {
    user_info.value = { ...newUser };
  },
  { deep: true }
);

const fetchClassNames = async () => {
  error.value = "";
  try {
    const res = await classNames();
    classOptions.value = res;
    // console.log("classOptions", classOptions.value);
 
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load users.";
    console.error("Error fetching users:", err);
  }
};


const updateUser = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const updatedData = { ...state }; //but state is a reactive object, not a ref. So state.value doesn't exist.

  try {
    const formData = new FormData();
    formData.append("first_name", updatedData.user.first_name);
    formData.append("last_name", updatedData.user.last_name);
    formData.append("email", updatedData.user.email);
    formData.append("username", updatedData.user.username);
    formData.append("_password", updatedData._password);

    if (Array.isArray(updatedData.class_info)) {
      // Prepare the class_info as an array of objects
      updatedData.class_info.forEach((classItem) => {
        formData.append("class_info[]", JSON.stringify(classItem)); // Use JSON.stringify to send it correctly
      });
    }

    const response = await axios.put(
      `${apiConfig.baseUrl}${apiConfig.veryfiedUser}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "USER-ID": updatedData.user.id,
        },
      }
    );
    // for (let pair of formData.entries()) {
    //   console.log(pair[0] + ': ' + pair[1]);
    // }
    emit("updatedUser", response);
    successMessage.value = "user updated successfully!";
  } catch (err) {
    error.value = `Error updating user: ${err.response ? err.response.data : err.message
      }`;
  }
};

// Clear Form
const clear = () => {
  user_info.value = { ...props.UserData };
  formKey.value++; // Reset form to clear inputs
};



onMounted(fetchClassNames);
</script>
